{
  "companyRoles": {
    "owner": "Owner",
    "member": "Member"
  },
  "projectRoles": {
    "producer": "Producer",
    "director": "Director",
    "member": "Contributor",
    "viewer": "Viewer",
    "support": "Support"
  },
  "roleHints": {
    "company": {
      "owner": "all projects, members, billing, sets spending limits",
      "member": "assigned projects only"
    },
    "project": {
      "producer": "settings, team, archive",
      "director": "settings, no team",
      "member": "content only",
      "viewer": "view only",
      "support": "view, generation logs"
    }
  },
  "people": {
    "you": "you",
    "allProjects": "All projects",
    "projectsAria": "Projects: {{count}}",
    "shareMark": "Share · {{company}}",
    "shareMarkAccess": "Share · {{company}} · {{access}}",
    "active": {
      "yes": "Yes",
      "no": "No"
    },
    "activity": {
      "title": "Activity for the period",
      "allGenerations": "All generations",
      "usageJournal": "Usage log",
      "perGeneration": "₽ per generation"
    },
    "projectsTable": {
      "project": "Project",
      "company": "Company",
      "role": "Role",
      "since": "In project since",
      "generations": "Generations",
      "spend": "Spend",
      "archived": "Archived",
      "notAssigned": "Not in project",
      "notAssignedHint": "No longer in the project, but had generations in the period"
    }
  },
  "shared": {
    "linkCopied": "Link copied",
    "copyFailed": "Could not copy",
    "editingNow": "Editing now",
    "email": "Email",
    "firstName": "First name",
    "lastName": "Last name",
    "role": "Role",
    "renewAndCopyLink": "Renew and copy link",
    "createInviteLink": "Create link",
    "createAndSendInvite": "Create and send",
    "override": "override",
    "inherits": "inherits",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "setForCompany": "set for company",
    "passwordPlaceholderSet": "•••••• (leave empty to keep)",
    "saving": "Saving…"
  },
  "members": {
    "pageTitle": "Members",
    "headTitle": "Company members",
    "tabs": {
      "members": "Members · {{count}}",
      "invitations": "Invitations · {{count}}"
    },
    "filters": {
      "searchMembers": "Name or email",
      "searchInvitations": "Email or name",
      "roleAll": "Role: all",
      "roleValue": "Role: {{role}}",
      "projectAll": "Project: all",
      "projects": "Projects",
      "projectSearch": "Project name…",
      "archivedGroup": "Archived",
      "showDeactivated": "Show deactivated",
      "reset": "Reset",
      "resetFilters": "Reset filters",
      "statusAll": "Status: all",
      "statusValue": "Status: {{status}}"
    },
    "columns": {
      "person": "Member",
      "email": "Email",
      "role": "Role",
      "projects": "Projects",
      "activity": "Activity",
      "active": "Active"
    },
    "footer": {
      "summary_one": "{{count}} member",
      "summary_other": "{{count}} members",
      "deactivatedTail_one": "{{count}} more deactivated",
      "deactivatedTail_other": "{{count}} more deactivated",
      "shown": "Showing {{shown}} of {{total}}",
      "roleFilter": "role: {{role}}"
    },
    "empty": {
      "filteredTitle": "Nobody matches these filters.",
      "filteredHint": "Try another role or project, or show deactivated members.",
      "table": "No members."
    },
    "menu": {
      "open": "Open in side peek",
      "addToProject": "Add to project",
      "makeOwner": "Make owner",
      "removeOwner": "Remove owner role",
      "deactivate": "Deactivate",
      "activate": "Activate",
      "remove": "Remove from company",
      "rowActions": "Actions"
    },
    "peek": {
      "close": "Close",
      "open": "Open",
      "openHint": "Open member page",
      "copyLink": "Copy link to card",
      "companyRole": "Company role",
      "companyRoleHint": "Sees only assigned projects. Owner — all projects, members and billing. Promoting to owner and removing the owner role require confirmation.",
      "roleLock": {
        "self": "You cannot change your own role",
        "last_owner": "Only owner",
        "deactivated": "Activate the member first"
      },
      "projects": "Projects · {{count}}",
      "addToProject": "Add to project",
      "ownerSeesAll": "Sees all projects",
      "ownerSeesAllHint": "Owners see all projects, including ones where they have no role.",
      "noProjects": "No project assignments.",
      "projectMeta": "{{type}} · {{count}} in team",
      "archivedMeta": "Archived · {{count}} in team",
      "projectRoleAria": "Role in “{{project}}”",
      "removeFromProject": "Remove from project",
      "details": "Details",
      "lastSeen": "Last activity",
      "joined": "Member since",
      "joinedInvitedBy": "{{date}} · invited by {{name}}",
      "spendMonth": "Spend this month",
      "usageLink": "Usage log",
      "spendLimit": "Spending limit",
      "spendLimitLine": "spent {{spent}} of {{limit}}",
      "spendLimitLeft": "left {{left}}",
      "spendLimitLeftResets": "left {{left}}, {{resets}}",
      "spendLimitNone": "No personal limit — only project and company limits apply.",
      "spendLimitEmpty": "Spending limits do not apply in this company.",
      "deactivatedStatus": "Deactivated by {{name}} · {{date}}. {{person}} cannot enter “{{company}}”; shown greyed out in lists, roles and assignments are kept.",
      "deactivatedStatusNoActor": "Deactivated {{date}}. {{person}} cannot enter “{{company}}”; shown greyed out in lists, roles and assignments are kept.",
      "activate": "Activate",
      "deactivate": "Deactivate",
      "remove": "Remove from company"
    },
    "dialogs": {
      "cancel": "Cancel",
      "close": "Close",
      "quotedName": "“{{name}}”",
      "makeOwnerTitle": "Make {{name}} an owner?",
      "makeOwnerIntro": "An owner manages the whole company, not individual projects:",
      "makeOwnerPoint1": "sees all projects, including ones without a role",
      "makeOwnerPoint2": "invites and removes members, changes roles",
      "makeOwnerPoint3": "sees billing and spend per member",
      "makeOwnerPoint4": "changes company settings",
      "makeOwnerAssignments": "Project roles are kept:",
      "ownersWillBe_one": "There will be {{count}} owner.",
      "ownersWillBe_other": "There will be {{count}} owners.",
      "makeOwnerConfirm": "Make owner",
      "removeOwnerTitle": "Remove the owner role from {{name}}?",
      "removeOwnerBody": "{{name}} will become a member and lose access to members, billing and company settings.",
      "removeOwnerNoProjects": "No project assignments — after the change no projects will be visible until they are added to a team.",
      "removeOwnerKeepsProjects": "Stays only on projects where they have a role:",
      "removeOwnerLastLeft": "You will remain the only owner.",
      "removeOwnerConfirm": "Remove owner role",
      "deactivateTitle": "Deactivate {{name}}?",
      "deactivatePoint1": "won’t be able to enter “{{company}}”; other companies are not affected",
      "deactivatePoint2": "stays greyed out in lists — in the company and in projects",
      "deactivatePoint2Projects": "stays greyed out in lists — in the company and in {{list}}",
      "deactivatePoint3": "generations, edits and spend stay under their name",
      "deactivatePoint4": "will get a deactivation email",
      "deactivateReversible": "You can restore access at any time with “Activate”.",
      "deactivateConfirm": "Deactivate",
      "removeTitle": "Remove {{name}} from the company?",
      "removeProjects": "will be removed from projects: {{list}}",
      "removeHistory": "generation and edit history stays under their name",
      "removeEmail": "will get a removal email",
      "removeInviteAgain": "You can invite them again with the same email. To close access temporarily, deactivate instead.",
      "removeConfirm": "Remove",
      "removeDeactivateInstead": "Deactivate",
      "addToProjectTitle": "Add {{name}} to a project",
      "addToProjectCompany": "Company",
      "addToProjectCompanyPlaceholder": "Choose a company",
      "addToProjectCompanySearch": "Find a company…",
      "addToProjectProject": "Project",
      "addToProjectPlaceholder": "Choose a project",
      "addToProjectSearch": "Find a project…",
      "addToProjectSearchEmpty": "Nothing found",
      "addToProjectRole": "Project role",
      "addToProjectEmpty": "All active projects are already assigned.",
      "addToProjectConfirm": "Add",
      "removeFromProjectTitle": "Remove {{name}} from “{{project}}”?",
      "removeFromProjectBody": "The project will disappear from {{name}}’s list. You can add it back with “Add to project”.",
      "removeFromProjectBodyOwner": "{{name}} loses the project role but keeps access as a company owner.",
      "removeFromProjectConfirm": "Remove"
    },
    "invitations": {
      "ttlHint_one": "Links are valid for {{count}} day · “Send again” extends the term and replaces the old link",
      "ttlHint_other": "Links are valid for {{count}} days · “Send again” extends the term and replaces the old link",
      "columns": {
        "invitee": "Invitee",
        "role": "Role",
        "projects": "Projects",
        "status": "Status",
        "invitedBy": "Invited by"
      },
      "status": {
        "pending": "pending · until {{date}}",
        "pendingNoDate": "pending",
        "expired": "expired {{date}}",
        "accepted": "accepted {{date}}",
        "declined": "declined {{date}}"
      },
      "statusFilter": {
        "pending": "pending",
        "expired": "expired",
        "accepted": "accepted",
        "declined": "declined"
      },
      "notInCompany": "no longer in the company",
      "alreadyMember": "already in the company",
      "history": "History",
      "invitedByLine": "{{name}} · {{date}}",
      "allProjects": "All projects",
      "resend": "Send again",
      "resendTitle": "Send the invitation again?",
      "resendBody": "The term will be extended until {{date}}. {{name}} will get a new email.",
      "resendWarning": "The old link from the email sent {{date}} will stop working.",
      "resendWarningNoDate": "The old link from the previous email will stop working.",
      "resendConfirm": "Send again",
      "copyLink": "Copy link",
      "copyLinkUnavailable": "The link is shown right after sending",
      "revoke": "Revoke",
      "revokeTitle": "Revoke the invitation for {{email}}?",
      "revokeBody": "The link will stop working. You can invite them again later.",
      "revokeConfirm": "Revoke",
      "inviteAgain": "Invite again",
      "footerActive_one": "{{count}} active",
      "footerActive_other": "{{count}} active",
      "footerHistory": "{{count}} in history",
      "emptyTitle": "No invitations yet.",
      "emptyHint_one": "The email link is valid for {{count}} day.",
      "emptyHint_other": "The email link is valid for {{count}} days.",
      "emptyFiltered": "No invitations match these filters."
    },
    "invite": {
      "button": "Invite",
      "title": "Invite to company",
      "titleProject": "Invite to “{{project}}”",
      "description_one": "Each address gets an email: who invited, role, projects and a link. The link is valid for {{count}} day.",
      "description_other": "Each address gets an email: who invited, role, projects and a link. The link is valid for {{count}} days.",
      "descriptionProject_one": "The invitee joins “{{company}}” as a member and immediately gets a role in this project. The link is valid for {{count}} day.",
      "descriptionProject_other": "The invitee joins “{{company}}” as a member and immediately gets a role in this project. The link is valid for {{count}} days.",
      "company": "Company",
      "companyPlaceholder": "Choose a company…",
      "companySearch": "Find a company…",
      "companySearchEmpty": "No company found",
      "email": "Email",
      "emailHint": "Enter, comma or space — next address. You can paste a list.",
      "nameHint": "Filled in when they accept the invitation.",
      "removeEmail": "Remove {{email}}",
      "companyRole": "Company role",
      "companyRoleHint": "Sees only assigned projects. Owner — all projects, members and billing.",
      "projects": "Projects",
      "optional": "optional",
      "projectSearch": "Find a project…",
      "projectSearchEmpty": "Nothing found",
      "projectsLoading": "Loading projects…",
      "projectsFailed": "Could not load projects.",
      "projectsRetry": "Retry",
      "archived": "archived",
      "projectOptionMeta": "{{type}} · {{count}}",
      "projectMeta": "{{type}} · {{count}} in team",
      "projectRoleAria": "Role in “{{project}}”",
      "removeProject": "Remove project",
      "ownerSeesAll": "Owners see all projects anyway. You can give them project roles right away.",
      "lockedRoleHint": "The company role is set by an owner. The invitee sees only projects they are assigned to.",
      "lockedRoleReason": "Producers invite members only",
      "projectLockedTitle": "Project",
      "otherProjectsHint": "Other projects are assigned by a company owner on the Members page.",
      "errors": {
        "invalid": "{{email}} — looks incomplete",
        "duplicate": "{{email}} — duplicated address",
        "taken": "{{email}} — already invited, send the invitation again from the list",
        "already_member": "{{email}} — already a company member",
        "already_member_deactivated": "{{email}} — member is deactivated, restore them with “Activate”",
        "pending_exists": "{{email}} — this address already has an invitation to the company",
        "unknown": "{{email}} — could not invite"
      },
      "errorsSummary": "Nothing was sent. Fix the addresses with errors or send only the rest — role and projects are kept.",
      "errorsFooter": "Addresses with errors will not be sent",
      "tooMany_one": "No more than {{count}} address at a time.",
      "tooMany_other": "No more than {{count}} addresses at a time.",
      "submitEmpty": "Send invitation",
      "submit_one": "Send {{count}} invitation",
      "submit_other": "Send {{count}} invitations",
      "cancel": "Cancel",
      "resultTitle_one": "{{count}} invitation sent",
      "resultTitle_other": "{{count}} invitations sent",
      "resultDescription": "Emails were sent on your behalf. If an email doesn’t arrive, share the link manually — it is valid until {{date}}.",
      "resultAll": "All addresses:",
      "resultStatus": "pending · until {{date}}",
      "resultReplaced": "Replaced an expired invitation from {{date}} — the old link no longer works",
      "resultTabHint": "Invitations are listed on the Invitations tab, where you can send the email again.",
      "copy": "Copy",
      "copyAll": "Copy all links",
      "inviteMore": "Invite more",
      "done": "Done"
    },
    "linkCopied": "Link copied",
    "copyFailed": "Could not copy",
    "page": {
      "headTitle": "{{name}} · member",
      "copyLink": "Copy page link",
      "joinedSince": "member since {{date}}",
      "invitedBy": "invited by {{name}}",
      "lastSeen": "last active: {{when}}",
      "companyCanvas": "Company canvas",
      "rosterOwners": "Owners",
      "rosterMembers": "Members",
      "rosterDeactivated": "Deactivated",
      "rosterEmpty": "No matches"
    }
  },
  "overview": {
    "title": "Overview",
    "rename": "Rename",
    "slugHint": "The company address (slug) is set at creation and never changes — links and emails depend on it.",
    "projects": "Projects",
    "myProjects": "My projects",
    "projectsInCompany": "in the company: {{count}}",
    "archivedCount": "{{count}} archived",
    "members": "Members",
    "deactivatedCount_one": "{{count}} deactivated",
    "deactivatedCount_other": "{{count}} deactivated",
    "allActive": "all active",
    "generations": "Generations",
    "running": "{{count}} running",
    "allTime": "all time",
    "owners": "Owners",
    "ownersMore": "{{name}} +{{count}}",
    "activity": "Activity over the year",
    "avgPerDay": "{{amount}} a day on average"
  },
  "settings": {
    "pageTitle": "AI settings",
    "headTitle": "Company AI settings",
    "integrationsCount": "Integrations · {{count}}",
    "connectionsHint": "Green — company has a connection override.",
    "connectionCount": "{{count}} connection",
    "connectionsHeading": "Connections · {{count}}",
    "noConnections": "No company connections yet — inherits global defaults.",
    "selectConnection": "Select a connection or create a company override.",
    "newConnectionTitle": "New company connection",
    "creatingOverride": "Creating override",
    "globalInherited": "Global default (inherited when empty)",
    "globalValue": "Global: {{value}}",
    "noGlobalConnection": "No global connection for {{kind}}.",
    "inheritsGlobalCredentials": "inherits global credentials",
    "passwordPlaceholderInheritGlobal": "inherits global (leave blank)",
    "overrideCount": "{{count}} override",
    "otherGroup": "Other",
    "googleGeminiTranscription": "Google Gemini · transcription",
    "saveSettings": "Save company settings",
    "saveNote": "Overrides for all integrations are saved.",
    "noSettings": "No settings available."
  },
  "models": {
    "pageTitle": "Models",
    "headTitle": "Company models",
    "accessTitle": "Available models",
    "defaultsTitle": "Default models",
    "defaultsHint": "An empty choice inherits the platform model. A project can still override it.",
    "inherit": "Same as platform ({{name}})",
    "save": "Save",
    "contexts": {
      "canvas_image": "Image",
      "canvas_video": "Video"
    }
  },
  "systemPrompts": {
    "pageTitle": "Prompts",
    "headTitle": "Company prompts",
    "companyOverrideLabel": "Company override (empty = inherit)",
    "placeholder": "Leave empty to use the global prompt",
    "showGlobalPrompt": "Show global prompt",
    "saveOverrides": "Save overrides",
    "noTemplates": "No templates in the database.",
    "filterPlaceholder": "Search by name…",
    "clearFilter": "Clear search",
    "filterEmpty": "No matches."
  }
}
